// extracted by mini-css-extract-plugin
export default {"root":"PaidHome_root__xeeHy","settings":"PaidHome_settings__Hy9tG"};